// Textos del módulo Cortesías. Ver src/i18n/textos.ts.
import { defineTextos } from '../textos.ts';

export const textosCortesias = defineTextos({
  errorCargando: 'Error cargando cortesías',
  reiniciasteApi: ' ¿Reiniciaste la API? La ruta /api/cortesias se carga al arrancar.',
  titulo: 'Cortesías',
  statCortesias: 'Cortesías',
  valorRegalado: 'Valor regalado',
  mesEnCurso: 'Mes en curso',
  todoHistorico: 'Todo el histórico',
  rangoFechas: 'Rango de fechas',
  periodoAria: 'Período',
  itemsRegalados: 'Items regalados (salen del inventario, van en $0 al cliente) — sede',
  desde: 'Desde',
  hasta: 'Hasta',
  persona: 'Persona',
  personaTitle: 'Filtra por quien registró la cortesía o a nombre de quién quedó',
  todasLasPersonas: 'Todas las personas',
  cargando: 'Cargando cortesías…',
  sinCortesias: 'No hay cortesías para este filtro. Se otorgan desde la mesa: botón 🎁',
  botonCortesia: 'Cortesía',
  juntoCategorias: 'junto a las categorías de productos.',
  colFechaHora: 'Fecha y hora',
  colItem: 'Item',
  colCant: 'Cant.',
  colValor: 'Valor',
  colOtorgadaPor: 'Otorgada por',
  colANombreDe: 'A nombre de',
  colPedido: 'Pedido',
  colFactura: 'Factura',
  sinFacturar: 'sin facturar',
  totalRegalado: 'Total regalado · {n} cortesías',
}, {
  errorCargando: 'Error loading comps',
  reiniciasteApi: ' Did you restart the API? The /api/cortesias route loads at startup.',
  titulo: 'Comps',
  statCortesias: 'Comps',
  valorRegalado: 'Value given away',
  mesEnCurso: 'Current month',
  todoHistorico: 'All history',
  rangoFechas: 'Date range',
  periodoAria: 'Period',
  itemsRegalados: 'Items given away (taken out of inventory, $0 to the customer), branch',
  desde: 'From',
  hasta: 'To',
  persona: 'Person',
  personaTitle: 'Filters by who recorded the comp or whose name it was put under',
  todasLasPersonas: 'Everyone',
  cargando: 'Loading comps…',
  sinCortesias: 'No comps for this filter. They are given from the table: the 🎁',
  botonCortesia: 'Comp',
  juntoCategorias: 'button next to the product categories.',
  colFechaHora: 'Date and time',
  colItem: 'Item',
  colCant: 'Qty',
  colValor: 'Value',
  colOtorgadaPor: 'Given by',
  colANombreDe: 'On behalf of',
  colPedido: 'Order',
  colFactura: 'Invoice',
  sinFacturar: 'not invoiced',
  totalRegalado: 'Total given away · {n} comps',
});
